// extracted by mini-css-extract-plugin
module.exports = {"file":"upload_file__N_CHB","file_custom":"upload_file_custom__GuHI5"};